<template>
  <div class="caraddstorelist">
    <m-title :titlelist="listitem"></m-title>
    <div class="carlist-box">
      <div class="box-title">
        <div class="carlist-box-title">
          <div class="title-left"></div>
          <div class="title-right">车辆充电列表</div>
        </div>
        <div class="carinfo">
          <div class="info-left">
            <div class="carplate">
              <div class="name">车牌号</div>
              <input
                type="text"
                class="inp1"
                v-model="conditions.plate"
                placeholder="请输入车牌号"
                clearable
              />
            </div>
            <!-- <div class="caraddinfo">
              <div class="name">充电状态</div>
              <div class="select_box">
                <el-select v-model="conditions.status" placeholder="请选择" size="small" clearable>
                  <el-option
                    class="inp"
                    v-for="(item, index) in selectastrict"
                    :key="index"
                    :label="item.text"
                    :value="item.status"
                  >
                  </el-option>
                </el-select>
              </div>
            </div> -->
            <div class="adddate">
              <div class="name">充电开始时间</div>
              
              <el-date-picker
                v-model="starttime"
                type="datetime"
                class="inps"
                value-format="yyyy-MM-dd HH:mm:ss"
                placeholder="充电开始时间">
            </el-date-picker>
            <span  class="name" style="margin-right: 0;">至</span>
            <el-date-picker
                  v-model="endtime"
                  type="datetime"
                  class="inps"
                  value-format="yyyy-MM-dd HH:mm:ss"
                  placeholder="充电结束时间">
              </el-date-picker>
            </div>
            <!-- <div class="adddate">
              <div class="name">充电结束时间</div>
              
            </div> -->
          </div>
          
        </div>
        <div style="display: flex;justify-content: space-between;align-items: center;padding: 8px 34px;">
          <div class="storestate">
          <div class="carplate">
            <div class="name">充电站</div>
            <el-select v-model="conditions.station" placeholder="请选择" style="width: 160px;" size="small" clearable>
              <el-option
                class="inp"
                v-for="(item, index) in station"
                :key="index"
                :label="item.name"
                :value="item.code"
              >
              </el-option>
            </el-select>
          </div>
          <div class="caraddinfo">
            <div class="name">充电桩</div>
            <el-select v-model="conditions.piles" placeholder="请选择" style="width: 160px;" size="small" clearable>
              <el-option
                class="inp"
                v-for="(item, index) in device"
                :key="index"
                :label="item.name"
                :value="item.code"
              >
              </el-option>
            </el-select>
          </div>
        </div>
        <div class="info-right">
            <button class="chaxun" @click="getsearch">查询</button>
            <button class="daochu" @click="printList">导出</button>
            <button class="reset" @click="reset">重置</button>
          </div>
        </div>
        
      </div>
      <div class="cartabel">
        <el-table :data="memberlist.list" style="width: 100%;" height="80%" 
        >
          <el-table-column
            label="序号"
            type="index"
            width="50px"
          ></el-table-column>
          
          <el-table-column prop="chargingPileName" label="充电桩名称" show-overflow-tooltip :render-header="renderHeader" >
          </el-table-column>
          <el-table-column prop="chargingPileId" label="充电桩编号" show-overflow-tooltip :render-header="renderHeader" >
          </el-table-column>
          <el-table-column label="开始充电时间" show-overflow-tooltip :render-header="renderHeader" >
            <template v-slot="res">
              <span>{{ mydateFormat(res.row.startTime, '时分秒') }}</span>
            </template>
          </el-table-column>
          <el-table-column label="结束充电时间" show-overflow-tooltip :render-header="renderHeader" >
            <template v-slot="res">
              <span>{{ mydateFormat(res.row.endTime, '时分秒') }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="chargeTime" label="充电时长（分钟）" show-overflow-tooltip :render-header="renderHeader" >
          </el-table-column>
          <el-table-column prop="chargePower" label="充电量（度）" show-overflow-tooltip :render-header="renderHeader" >
          </el-table-column>
          <el-table-column prop="chargeElecMoney" label="充电金额（元）" show-overflow-tooltip :render-header="renderHeader" >
          </el-table-column>
          <el-table-column prop="chargeServiceMoney" label="充电服务金额（元）" show-overflow-tooltip :render-header="renderHeader" >
          </el-table-column>
          <el-table-column prop="chargeMoney" label="充电总金额（元）" show-overflow-tooltip :render-header="renderHeader" >
          </el-table-column>
          <el-table-column prop="plateNumber" label="车牌号" show-overflow-tooltip :render-header="renderHeader" > </el-table-column>
          <el-table-column prop="driverName" label="司机" show-overflow-tooltip :render-header="renderHeader" > </el-table-column>
          <el-table-column prop="telephone" label="联系方式" show-overflow-tooltip :render-header="renderHeader" > </el-table-column>
        </el-table>
        <div class="msgstatistics">
          <span style="margin-right: 20px">合计 充电次数:{{ memberlist.totalCount }}次</span>
          <span style="margin-right: 20px">充电时长:{{chargehj?chargehj.chargeTime:0 }}分钟</span>
          <span style="margin-right: 20px">充电量:{{ chargehj? chargehj.chargePower:0 }}度</span>
          <span style="margin-right: 20px">充电金额:{{ chargehj? chargehj.chargeElecMoney:0 }}元</span>
          <span style="margin-right: 20px">充电服务金额:{{ chargehj? chargehj.chargeServiceMoney:0 }}元</span>
          <span style="margin-right: 20px">充电总金额:{{ chargehj? chargehj.chargeMoney:0 }}元</span>
        </div>
        <div class="paginations">
          <el-pagination
            :page-size="conditions.limit"
            layout="total,prev, pager,next, jumper"
            :total="memberlist.totalCount"
            :current-page="memberlist.page"
            @current-change="handleCurrentChange"
          >
          </el-pagination>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import mTitle from '@/components/mTitle';
import mSelect from '@/components/mSelect';
import { printExcel } from '@/plugins/other.js';
export default {
  components: {
    mTitle,
    mSelect,
  },
  data() {
    return {
      listitem: [{ name: '车辆充电列表' }],
      plate: '', //车牌号
      addstatus: '', //充电状态
      // datevalue: '', //开始结束时间
      selectastrict: [{status:null,text:'全部'}, {status:2,text:'充电中'},{status:1,text:'空闲'}],
      params: '',
      // value: '',
      // starttime: '',
      // endtime: '',
      conditions: {
        page: 1,
        limit: 20,
        order: 'desc',
        sidx: 'gmt_modified',
        endtime: '',
        order: '', //排列方式
        params: null,
        piles: '', //充电桩
        plate: '', //车牌
        sidx: '', //排序字段
        starttime: '', //开始时间
        station: '', //充电站
        status: null,
      },
      memberlist: {},
      station: [],
      device: [],
      devicevalue: '',
      // datevalue: '',
      endtime: '',
      starttime: '',
      chargehj:null
    };
  },
  created() {
    if(this.$route.query.obj){
      this.conditions.station=JSON.parse(this.$route.query.obj).station?JSON.parse(this.$route.query.obj).station:''
      this.conditions.piles=JSON.parse(this.$route.query.obj).piles?JSON.parse(this.$route.query.obj).piles:''
      this.starttime=JSON.parse(this.$route.query.obj).starttime?JSON.parse(this.$route.query.obj).starttime+' '+'00:00:00':''
      this.endtime=JSON.parse(this.$route.query.obj).endtime?JSON.parse(this.$route.query.obj).endtime+' '+'23:59:59':''
    }
    this.getMemberlist();
    this.getdownstation(); //充电站
    // this.getdownstation();
    this.getdownDevice();
  },
  methods: {
    // renderHeader(h, data) {
    //   console.log(data.column.label);
    //   return h("span", [
    //     h(
    //       "el-tooltip",
    //       {
    //         attrs: {
    //           class: "item",
    //           effect: "dark",
    //           content: data.column.label,
    //           placement: "top",
    //         },
    //       },
    //       [h("span", data.column.label)]
    //     ),
    //   ]);
    // },
    // 表格数据的获取
    async getMemberlist() {
      this.conditions.starttime=this.starttime;
      this.conditions.endtime=this.endtime;
      const { data } = await this.$http(
        'api1',
        '/api/replenish/log/list',
        'get',
        this.conditions
      );
      if (data.code != 0) return console.log('获取表格数据失败');
      this.memberlist = data.data;
      this.chargehj=data.hj
    },
    // 分页
    handleCurrentChange(index) {
      if (this.memberlist.totalCount < this.conditions.limit) return;
      this.conditions.page = index;
      this.getMemberlist();
    },
    //查询
    getsearch() {
      // this.starttime = this.datevalue[0];
      // this.endtime = this.datevalue[1];
      this.getMemberlist();
    },
    //重置
    reset() {
      this.conditions.station = '';
      this.conditions.piles = '';
      this.starttime = '';
      this.endtime = '';
      this.conditions.status = null;
      this.getMemberlist();
      this.conditions.plate = '';
    },
    // 下拉充电桩
    async getdownDevice() {
      const { data } = await this.$http(
        'api1',
        'api/replenish/station/downEnergyDevice',
        'get'
      );
      if (!data || data.code != '0') return;
      this.device = data.data;
    },
    // 下拉充电站
    async getdownstation() {
      const { data } = await this.$http(
        'api1',
        'api/replenish/station/downEnergyStation',
        'get'
      );
      if (!data || data.code != '0') return;
      this.station = data.data;
    },
    //导出
    printList() {
      printExcel.call(
        this,
        '/api/replenish/log/exportEnergyLoglist',
        '充电记录列表',
        this.conditions
      );
    },
  },
};
</script>

<style lang="scss" scoped>
.caraddstorelist {
  height: 100%;

  .carlist-box {
    width: 100%;
    height: calc(100% - 50px);
    background: #f5f6fa;
    border-radius: 20px;
    overflow: auto;
    padding: 10px;
    box-sizing: border-box;

    .box-title {
      width: 100%;
      background-color: #fff;

      .carlist-box-title {
        width: 100%;
        padding: 20px 25px;
        box-sizing: border-box;
        display: flex;
        justify-content: flex-start;
        align-items: center;

        .title-left {
          width: 12px;
          height: 26px;
          background: #17b6a1;
          border-radius: 6px;
          margin-right: 11px;
        }

        .title-right {
          font-size: 20px;
          font-family: PingFang SC;
          font-weight: 600;
          color: #2d3748;
        }
      }

      .carinfo {
        width: 100%;
        padding: 8px 34px;
        box-sizing: border-box;
        // display: flex;
        // justify-content: space-between;
        // align-items: center;

        .info-left {
          display: flex;
          justify-content: flex-start;
          align-items: center;

          .carplate,
          .caraddinfo,
          .adddate {
            display: flex;
            justify-content: flex-start;
            align-items: center;
            margin-right: 20px;

            .name {
              font-size: 80%;
              font-family: PingFang SC;
              font-weight: bold;
              color: #333333;
              margin-right: 15px;
            }

            .inp1{
              width: 160px;
              height: 30px;
              background: #f3f4f5;
              padding-left: 15px;
              border-radius: 4px;
              border: none;
              outline: none;
            }
            .inp{
              width: 160px;
              height: 30px;
              background: #f3f4f5;
              border-radius: 4px;
              border: none;
              outline: none;
            }
            .inps{
              width: 200px;
              height: 30px;
              background: #f3f4f5;
              border-radius: 4px;
              border: none;
              outline: none;
            }
          }
        }

        
      }
      .info-right {
          display: flex;
          justify-content: flex-end;
          align-items: center;
          width: 22%;

          .chaxun,
          .daochu {
            width: 80px;
            height: 30px;
            background: #17b6a1;
            border-radius: 8px;
            color: #fff;
            line-height: 30px;
            text-align: center;
            border: none;
            font-size: 80%;
            margin-left: 20px;
          }

          .reset {
            width: 80px;
            height: 30px;
            background-color: #f5f6fa;
            border-radius: 8px;
            color: #17b6a1;
            line-height: 30px;
            text-align: center;
            border: none;
            font-size: 80%;
            margin-left: 20px;
          }
        }
      .storestate {
        width: 100%;
        
        box-sizing: border-box;
        display: flex;
        justify-content: flex-start;
        align-items: center;

        .carplate,
        .caraddinfo {
          display: flex;
          justify-content: flex-start;
          align-items: center;
          margin-right: 20px;

          .name {
            font-size: 80%;
            font-family: PingFang SC;
            font-weight: bold;
            color: #333333;
            margin-right: 15px;
          }
        }
      }
    }
    .select_box {
      display: inline-block;
      vertical-align: middle;
      width: 160px;
      height: 30px;
      background: #f3f4f5;
      border-radius: 2px;
    }

    .cartabel {
      padding-top: 10px;
      width: 100%;
      // height: 520px;
      height: calc(100% - 160px);
      background-color: #fff;
      box-sizing: border-box;
      .msgstatistics{
        margin-top: 10px;
        font-size: 80%;
        line-height: 35px;
        text-align: center;
        color: #fff;
        font-weight: bold;
        background: #17B6A1;
      }
      .paginations {
        margin-top: 15px;
        display: flex;
        justify-content: center;
      }
    }
  }
}
</style>
